<template >
  <v-app  >
    <v-navigation-drawer v-if="auth && user" app
                         v-model="drawer"
                         :mini-variant.sync="mini"
                         permanent
    >

      <v-list dense  >
        <img src="./assets/image/logo.webp" alt="Logo" class="logo_custom" >
        <hr class="mb-8" style="border-bottom: 1px solid #ffffff" >
        <v-list-item
            link
            to="/"
        >
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>หน้าหลัก</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>


      <v-list dense  v-if="user && (user.role == 'admin' || (user.role == 'user' && user.permissions.split(',').includes('1')))" >
        <v-list-item
            link
            to="/calculate"
        >
          <v-list-item-icon>
            <v-icon>mdi-calculator-variant-outline</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>คำนวน</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>

      <v-list-group
          :value="false"
          prepend-icon="mdi-file-document-outline"
          v-if="user && (user.role == 'admin' || (user.role == 'user' && ['2','3','4'].some(p => user.permissions.split(',').includes(p))))"
      >
        <template v-slot:activator>
          <v-list-item-title>จัดการไฟล์</v-list-item-title>
        </template>

        <v-list-item
            to="/ncp_data"
            link
            v-if="user && (user.role == 'admin' || (user.role == 'user' && user.permissions.split(',').includes('2')))"
        >
          <v-list-item-content>
            <v-list-item-title class="custom-list-item-title" >จัดการข้อมูล NCP</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
            to="/ng_data"
            link
            v-if="user && (user.role == 'admin' || (user.role == 'user' && user.permissions.split(',').includes('3')))"
        >
          <v-list-item-content>
            <v-list-item-title class="custom-list-item-title" >จัดการข้อมูล NG</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
            to="/lead_data"
            link
            v-if="user && (user.role == 'admin' || (user.role == 'user' && user.permissions.split(',').includes('4')))"
        >
          <v-list-item-content>
            <v-list-item-title class="custom-list-item-title" >จัดการข้อมูล LEAD</v-list-item-title>
          </v-list-item-content>
        </v-list-item>


      </v-list-group>

      <v-list dense>
        <v-list-item
            link
            to="/employee_attendance"
            v-if="user && (user.role == 'admin' || (user.role == 'user' && user.permissions.split(',').includes('5')))"
        >
          <v-list-item-icon>
            <v-icon>mdi-clipboard-text-clock</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>จัดการข้อมูลเข้าออกงาน</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>

      <v-list dense>
        <v-list-item
            link
            to="/employee"
            v-if="user && (user.role == 'admin' || (user.role == 'user' && user.permissions.split(',').includes('6')))"
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>จัดการข้อมูลพนักงาน</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>

      <v-list dense>
        <v-list-item
            link
            to="/user"
            v-if="user && (user.role == 'admin' || (user.role == 'user' && user.permissions.split(',').includes('7')))"
        >
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>จัดการข้อมูลผู้ใช้งาน</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>












      <v-list dense>
        <v-list-item
            link
            v-on:click="Logout()"
        >
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>ออกจากระบบ</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>
    <v-app-bar v-if="auth" class="top_bar_container" app>
      <div class="list_menu" >

        <v-btn
            class="no-padding hamburger_menu"
            icon
            @click.stop="mini = !mini"
        >
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </div>


      <div></div>
      <div></div>
    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>

    <!--
    <v-footer v-if="auth" class="footer_custom" app>
      <div align="center" >
        RISE BUDDY © 2024 FWD
      </div>
    </v-footer> -->

  </v-app>
</template>

<script>

import {baseUrl} from "./const/api";
import Vuetify from "vuetify";

export default {
  name: 'App',
  vuetify: new Vuetify({
    theme: {
      dark: false,
      themes: {
        light: {
          primary: '#10357F',
          secondary: '#DBDFE1',
          success: '#02CAEF',
          danger: '#ED1C24',
          warning: '#ffc107',
          info: '#17a2b8',
          light: '#f8f9fa',
          dark: '#212529',
          gray: '#6c757d',
          red: '#841C3C',
          green: '#02CAEF',
          yellow: '#ffc107',
        }
      }
    }
  }),
  components: {},
  data () {
    return {
      version_system:"v 1.2.0",
      version_api:"0",
      version_service:"0",
      baseUrl:baseUrl,
      auth: localStorage.getItem('user') ? true:false,
      user: JSON.parse(localStorage.getItem('user')),
      items: [
        { title: 'Home', icon: 'mdi-home-city' },
        { title: 'My Account', icon: 'mdi-account' },
        { title: 'Users', icon: 'mdi-account-group-outline' },
      ],
      mini: true,
    }
  },
  methods:{
    Logout(){
      localStorage.removeItem('user');
      window.location = "/login"
    },
    CheckLogin(){
      console.log(this.$router.currentRoute.path)
      const UserData = localStorage.getItem('user');
      if(this.$router.currentRoute.path === "/file_lists"){
        console.log("")
      }
      else if(!UserData && this.$router.currentRoute.path !== "/login"   ){
       window.location = "/login"
      }else{

        console.log("Nologin")
      }
    },
  },
  mounted() {
    this.CheckLogin()
    console.log(this.$route.name)
  },
  created() {
    //console.log(process.env)
  }
};
</script>
<style>
.footer_custom{
  justify-content: center;
}
.v-toolbar__content{
  display: flex;
  height: 64px;
  width: 100%;
  justify-content: space-between;
}
.version_show{
  padding: 1rem;
  font-size: 0.8rem;
  font-weight: 500;
}
.list_item_custom {
  color: #fc6f1a !important;
}
</style>
